import React from "react"
import { HandleImages } from "../components/functions"
import Layout from "../components/layout"
import "../css/terms.css"
import SEO from  "../components/seo"
import ActOnNew from "../components/act-on/act-on-new"


class Cancel extends React.Component {

  render() {

    
    return (
      <Layout>
      <SEO title="Ares Accomplishments Verification" />
<div className="terms-wrapper">
        <div>
            <HandleImages name="aresSplash"/>
        </div>

        <div>



        <div  className="terms">

        <div style={{margin:"1em", maxWidth:"75ch"}} >
            <h1>Your terms, your time, and your talents are critical to staying competitive and maintaining your certification.</h1> 
            <p> 
Being a professional in such a highly evolving industry means staying up-to-date on the latest tools, threats, best practices and procedures, and we’re thrilled you have chosen Circadence’s Project Ares to keep your knowledge and skills fresh.</p>

<ol>

<li style={{marginBottom:"1em"}}>Please complete the brief webform below to request verification of completed activities within Project Ares.</li>
<li style={{marginBottom:"1em"}}>Our Customer Support Team will confirm your work, and follow up with you via e-mail to provide you with formal documentation to be submitted directly to your certification body.</li>
<li style={{marginBottom:"1em"}}>This official record will include relevant details on the activity you’ve completed, the date on which you completed it, the number of CEU/CPE hours credited to your work, and a unique certificate number for your reference.</li>

</ol>
</div>

 <ActOnNew id="6696b4c0-2069-42ea-b84c-2c8f955233f5"/> 

</div>




        </div>



        </div>
      </Layout>
    )
  }
}

export default Cancel
